import styled from 'styled-components';

const ParticleLoaderWrapper = styled.div`
  align-content: center;
  display: flex;
  justify-content: center;
  margin: auto;
  position: relative;
  width: 100%;

  @keyframes loader-spin {
    0%,
    100% {
      transform: translate(0);
    }
    25% {
      transform: translate(160%);
    }
    50% {
      transform: translate(160%, 160%);
    }
    75% {
      transform: translate(0, 160%);
    }
  }
`;

const ParticleLoader = styled.div`
  height: 50px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50px;

  hr {
    animation: loader-spin 2s ease infinite;
    border: 0;
    border-radius: var(--size-border-radius-circle);
    height: 35%;
    margin: 0;
    position: absolute;
    width: 35%;

    :first-child {
      animation-delay: -1.5s;
      background: var(--color-accent-primary-weak);
    }

    :nth-child(2) {
      animation-delay: -1s;
      background: var(--color-warning-default);
    }

    :nth-child(3) {
      animation-delay: -0.5s;
      background: #fda543;
    }

    :last-child {
      background: var(--color-blue-200);
    }
  }
`;

export { ParticleLoader, ParticleLoaderWrapper };
